export default __webpack_public_path__ + "static/fv-nr-5-4b236d5029c47dc186218c95da89e89d.avif";